import { render, staticRenderFns } from "./UserCancelComments.vue?vue&type=template&id=78e4e530&"
import script from "./UserCancelComments.vue?vue&type=script&lang=js&"
export * from "./UserCancelComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports